<template>
  <el-table-column
    prop="street"
    sortable="custom"
    label="Utca"
    min-width="150"
    show-overflow-tooltip=""
  >
    <template slot-scope="scope">
      {{ scope.row.address }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
